import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import HorizontalSlider from "../../../common/HorizontalSlider";

import styles from "./children.module.scss";
import {longCurrency} from "../../../../utils/currency";

function Children({items, active, activeItem, onClick, currency}) {
  return (
    <div className={classNames(styles.root, active && styles.rootActive)}>
      <HorizontalSlider
        dots={false}
        arrows={true}
        slidesToShow={5}
        variableWidth
        infinite={false}
        swipeToSlide={true}
        responsive={[
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          }
        ]}
        className={styles.slider}
      >
        {items.map(({product, title, assetURL, minPrice}) => (
          <div key={product} onClick={() => onClick(product)}>
            <div
              className={classNames(
                styles.item,
                product === activeItem && styles.itemSelected
              )}
            >
              <div className={styles.preview}>
                <img loading="lazy" src={assetURL} alt={title} />
              </div>
              <div className={styles.title}>
                {title.length > 25 ? `${title.slice(0, 25)}...` : title}
              </div>
              <div className={styles.price}>от {minPrice}{longCurrency(currency, minPrice)}</div>
            </div>
          </div>
        ))}
      </HorizontalSlider>
    </div>
  );
}

Children.propTypes = {
  items: PropTypes.array,
  active: PropTypes.bool,
  activeItem: PropTypes.string,
  onClick: PropTypes.func
};

const mapStateToProps = (state) => ({
  currency: state.currency
})

export default connect(mapStateToProps)(Children);
